import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageSwitchComponent } from 'src/app/core/components/language-switch/language-switch.component';

/**
 * Frame of the sign-up and sign-in pages: the inset panel with the page's
 * own 400px column. Sign-up (the Framer register page) adds a testimonial
 * card on the left on wide screens; sign-in (the login page) is the panel
 * alone. `wide` gives pages with lists (not forms) a wider column.
 */
@Component({
  selector: 'app-auth-shell',
  templateUrl: './auth-shell.component.html',
  imports: [NgClass, TranslocoModule, LanguageSwitchComponent],
  host: { class: 'block' },
})
export class AuthShellComponent {
  readonly testimonial = input(true);

  readonly wide = input(false);
}
